const o = (t) => ({
  wrapper: {
    position: "relative",
    backgroundColor: t.palette.common.grey400,
    minHeight: 450
  },
  bgWrap: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    "& img": {
      objectFit: "cover"
    }
  },
  bannerContent: {
    position: "relative",
    textAlign: "center",
    maxWidth: 700,
    margin: "0 auto"
  },
  title: {
    fontSize: "56px",
    color: t.palette.common.white,
    fontWeight: t.typography.fontWeightBold,
    lineHeight: 1.2,
    "@media(max-width: 600px)": {
      fontSize: t.typography.fontSize30
    }
  },
  subTitle: {
    color: t.palette.common.white,
    "@media(max-width: 600px)": {
      fontSize: t.typography.fontSize14
    }
  },
  quoteBtn: {
    maxWidth: 260,
    "@media(max-width: 600px)": {
      maxWidth: "100%"
    }
  }
}), i = o;
export {
  i as default
};
